import { getAllOrganizationUsers as getAllOrganizationUsersApi } from '../../apiFactory/DashboardDesigner/P3fy';

// Action Types
export const GET_ORGANIZATION_USERS_REQUEST = 'GET_ORGANIZATION_USERS_REQUEST';
export const GET_ORGANIZATION_USERS_SUCCESS = 'GET_ORGANIZATION_USERS_SUCCESS';
export const GET_ORGANIZATION_USERS_FAILURE = 'GET_ORGANIZATION_USERS_FAILURE';

// Action Creators
export const getAllOrganizationUsers = (organizationId) => {
  return async (dispatch) => {
    dispatch({ type: GET_ORGANIZATION_USERS_REQUEST });
    try {
      const users = await getAllOrganizationUsersApi(organizationId);
      dispatch({ type: GET_ORGANIZATION_USERS_SUCCESS, payload: users });
      return users;
    } catch (error) {
      dispatch({ type: GET_ORGANIZATION_USERS_FAILURE, error });
      throw error;
    }
  };
}; 